import zipcodeApi from '~/clientApis/zipcodeApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const assignZipcode = async () => {
    const { zipcodeStore, regionStore } = getStore();
    zipcodeStore.setIsGettingZipcode(true);
    try {
        await zipcodeApi.assignZipcode(regionStore.selectedRegionId);
    } catch (error) {
        showMessageModal('error', 'Error assigning zipcode');
        throw error;
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};

export default assignZipcode;
